module.exports = __webpack_public_path__ + "static/media/card.9948f124.svg";